import { render, staticRenderFns } from "./withdrawal-status.vue?vue&type=template&id=2564665f&scoped=true"
import script from "./withdrawal-status.vue?vue&type=script&lang=js"
export * from "./withdrawal-status.vue?vue&type=script&lang=js"
import style0 from "./withdrawal-status.vue?vue&type=style&index=0&id=2564665f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2564665f",
  null
  
)

export default component.exports